import React from "react";

const AddUser = () => {
  return (
    <div>
      <h2>Add User</h2>
      {/* Your add user form or logic goes here */}
    </div>
  );
};

export default AddUser;
